<app-layout>
  <div class="main dashboard-main">
    <div class="header-table">
      <div class="header-title-block">
        <app-titulo>{{ dashboardTitle }}</app-titulo>
      </div>
      <div class="header-buttons">
        <app-botao
          type="secundario"
          class="button"
          text="Gerar PDF"
          icon="assets/download.svg"
          [disabled]="isExportingPdf"
          (click)="gerarPDF()"></app-botao>
      </div>
    </div>

    <div #dashboardPdfContent class="dashboard-pdf-content" [class.exporting-pdf]="isExportingPdf">
      <div class="pdf-report-meta">
        <p class="pdf-report-title">{{ dashboardTitle }}</p>
        <p class="pdf-report-period" *ngIf="form.controls['DT_INIC'].value || form.controls['DT_FIM'].value">
          Período: {{ formatFilterDate(form.controls['DT_INIC'].value) }}
          até {{ formatFilterDate(form.controls['DT_FIM'].value) }}
        </p>
        <p class="pdf-report-period" *ngIf="transportadoraFiltroLabel">
          Transportadora: {{ transportadoraFiltroLabel }}
        </p>
        <p class="pdf-report-generated" *ngIf="pdfGeneratedAt">
          Gerado em {{ pdfGeneratedAt | date: 'dd/MM/yyyy HH:mm' }}
        </p>
      </div>

      <div class="filters-card">
        <form [formGroup]="form" class="table-filters">
          <app-input
            type="datetime-local"
            label="Data Início"
            placeholder="Digite aqui"
            name="DT_INIC"
            formControlName="DT_INIC"
            width="100%"></app-input>
          <app-input
            type="datetime-local"
            label="Data Final"
            placeholder="Digite aqui"
            name="DT_FIM"
            formControlName="DT_FIM"
            width="100%"></app-input>
        </form>
        <form [formGroup]="transportadoraForm" class="table-filters transportadora-filter">
          <app-input
            type="dropdown"
            label="Transportadora"
            placeholder="Todas"
            name="NM_TRND"
            formControlName="NM_TRND"
            [selectData]="transportadoraOptions"
            width="100%"></app-input>
        </form>
      </div>

      <section class="dashboard-section">
        <div class="kpi-grid">
          <div class="kpi-card" *ngFor="let kpi of kpis">
            <span class="kpi-label">{{ kpi.label }}</span>
            <span class="kpi-value">{{ kpi.value }}</span>
            <span class="kpi-hint" *ngIf="kpi.hint">{{ kpi.hint }}</span>
          </div>
        </div>
      </section>

      <section class="dashboard-section">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('descricao')">
          <span>Recebimento por descrição</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('descricao')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('descricao')">
          <p class="chart-note">Diária reúne os caminhões avulsos, que entraram sem agendamento.</p>
          <p class="chart-empty" *ngIf="!porDescricao.length">Nenhum recebimento no período selecionado.</p>
          <div class="charts-grid" *ngIf="porDescricao.length">
            <section class="chart-card">
              <h3>Quantidade de caminhões</h3>
              <div class="bar-chart horizontal chart-scroll">
                <div class="h-bar-row" *ngFor="let item of porDescricao">
                  <span class="h-bar-label" [title]="item.Label">{{ item.Label }}</span>
                  <div class="h-bar-track">
                    <div class="h-bar-fill" [style.width.%]="barHeight(item.Quantidade, porDescricaoQuantidade)"></div>
                  </div>
                  <span class="h-bar-value">{{ item.Quantidade }}</span>
                </div>
              </div>
            </section>

            <section class="chart-card">
              <h3>Valor por descrição</h3>
              <div class="bar-chart horizontal chart-scroll">
                <div class="h-bar-row money" *ngFor="let item of porDescricao">
                  <span class="h-bar-label" [title]="item.Label">{{ item.Label }}</span>
                  <div class="h-bar-track">
                    <div class="h-bar-fill sales-value" [style.width.%]="barHeight(item.Valor, porDescricaoValor)"></div>
                  </div>
                  <span class="h-bar-value">{{ formatCurrency(item.Valor) }}</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>

      <section class="dashboard-section">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('transportadora')">
          <span>Recebimento por transportadora</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('transportadora')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('transportadora')">
          <p class="chart-empty" *ngIf="!porTransportadora.length">Nenhuma transportadora no período selecionado.</p>
          <div class="charts-grid transporter-charts" *ngIf="porTransportadora.length">
            <section class="chart-card">
              <h3>Quantidade por transportadora</h3>
              <div class="bar-chart horizontal chart-scroll">
                <div class="h-bar-row" *ngFor="let item of porTransportadora">
                  <span class="h-bar-label">{{ item.Label }}</span>
                  <div class="h-bar-track">
                    <div class="h-bar-fill alt" [style.width.%]="barHeight(item.Quantidade, transportadoraQuantidade)"></div>
                  </div>
                  <span class="h-bar-value">{{ item.Quantidade }}</span>
                </div>
              </div>
            </section>

            <section class="chart-card">
              <h3>Valor por transportadora</h3>
              <div class="bar-chart horizontal chart-scroll">
                <div class="h-bar-row money" *ngFor="let item of porTransportadora">
                  <span class="h-bar-label">{{ item.Label }}</span>
                  <div class="h-bar-track">
                    <div class="h-bar-fill sales-value" [style.width.%]="barHeight(item.Valor, transportadoraValor)"></div>
                  </div>
                  <span class="h-bar-value">{{ formatCurrency(item.Valor) }}</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>

      <section class="dashboard-section">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('pagamento')">
          <span>Forma de pagamento</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('pagamento')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('pagamento')">
          <section class="chart-card">
            <h3>Quantidade e valor por forma de pagamento</h3>
            <div class="pay-list" *ngIf="porFormaPagamento.length; else emptyPagamento">
              <div class="pay-row pay-head">
                <span>Forma</span>
                <span></span>
                <span>Qtd.</span>
                <span>Valor</span>
              </div>
              <div class="pay-row" *ngFor="let item of porFormaPagamento">
                <span class="pay-label">{{ item.Label }}</span>
                <div class="h-bar-track">
                  <div class="h-bar-fill" [style.width.%]="barHeight(item.Valor, pagamentoValor)"></div>
                </div>
                <span class="pay-qty">{{ item.Quantidade }}</span>
                <strong class="pay-val">{{ formatCurrency(item.Valor) }}</strong>
              </div>
            </div>
            <ng-template #emptyPagamento>
              <p class="chart-empty">Nenhum pagamento no período selecionado.</p>
            </ng-template>
          </section>
        </div>
      </section>

      <section class="dashboard-section">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('anual')">
          <span>Quantidade e valor de caminhões por ano e mês</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('anual')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('anual')">
          <section class="chart-card">
            <p class="chart-note">Mostra o histórico completo. O período acima não altera esta tabela.</p>
            <div class="year-filter">
              <form [formGroup]="grupoForm" class="table-filters">
                <app-input
                  type="dropdown"
                  label="Descrição"
                  placeholder="Selecione"
                  name="DS_GRUPO"
                  formControlName="DS_GRUPO"
                  [selectData]="grupoOptions"
                  width="100%"></app-input>
              </form>
            </div>
            <div class="year-table-wrap">
              <table class="year-table">
                <thead>
                  <tr>
                    <th rowspan="2">Meses</th>
                    <th *ngFor="let ano of anos" colspan="2">{{ ano }}</th>
                  </tr>
                  <tr>
                    <ng-container *ngFor="let ano of anos">
                      <th>Qtd.</th>
                      <th>Valor</th>
                    </ng-container>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let mes of meses">
                    <td>{{ mes.nome }}</td>
                    <ng-container *ngFor="let ano of anos">
                      <td>{{ quantidadeNoMes(ano, mes.mes) }}</td>
                      <td class="year-value">{{ valorNoMes(ano, mes.mes) }}</td>
                    </ng-container>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </section>
    </div>
  </div>

  <app-loader [isLoading]="isLoading || isExportingPdf"></app-loader>
</app-layout>
